import type { ButtonHTMLAttributes, ReactElement, ReactNode } from 'react';

import { onboardingImageUrl } from './onboarding-image.js';

export interface OnboardingChoiceCardProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  imageSeed: string;
  label: ReactNode;
  hint?: ReactNode;
  selected?: boolean;
}

export function OnboardingChoiceCard({
  imageSeed,
  label,
  hint,
  selected = false,
  className,
  type = 'button',
  ...rest
}: OnboardingChoiceCardProps): ReactElement {
  const classes = [
    'onboarding-choice',
    selected ? 'onboarding-choice--selected' : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} aria-pressed={selected} {...rest}>
      <span className="onboarding-choice__media" aria-hidden>
        <img src={onboardingImageUrl(imageSeed)} alt="" loading="lazy" width={720} height={900} />
      </span>
      <span className="onboarding-choice__body">
        <span className="onboarding-choice__label">{label}</span>
        {hint ? <span className="onboarding-choice__hint">{hint}</span> : null}
      </span>
    </button>
  );
}
